import * as types from './types';

const INITIAL_STATE = {
  servedItems: [],
  selectedServedItems: [],
  fetchError: '',
  fetching: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.ASSIGN_SERVED_ITEMS_TO_SITE_GET_DATA:
      const servedItems = payload.servedItems.map(item => {
        item['MealId'] = item.Id.substr(0, 1);
        return item;
      });
      return {
        ...state,
        servedItems,
      };

    case types.ASSIGN_SERVED_ITEMS_TO_SITE_GET_SITES_SERVED_ITEMS:
      const selectedServedItems = payload.selectedServedItems.map(
        item => item.Id
      );
      return {
        ...state,
        selectedServedItems,
      };

    case types.ASSIGN_SERVED_ITEMS_TO_SITE_SAVE_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };

    case types.ASSIGN_SERVED_ITEMS_TO_SITE_ERROR:
      return { ...state, fetchError: payload };

    case types.ASSIGN_SERVED_ITEMS_TO_SITE_FETCHING:
      return { ...state, fetching: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/state/servedItemsToSite/reducer.js